import UUID from '../utils/uuid';

export class Dep {
    static target: any = null;
    id: string;
    watchers: any;

    constructor() {
        this.id = `depId:${new UUID().id}`;
        this.watchers = [];
    }

    depend() {
        let targetWatcher = Dep.target;

        if (!targetWatcher) {
            return;
        }

        // 把dep关联到当前激活的watcher
        targetWatcher.addDep(this);
    }

    addSub(watcher) {
        this.watchers.push(watcher);
    }

    notify() {
        this.watchers.forEach((watcher) => {
            watcher.update();
        })
    }
}

export function setTarget(watcher) {
    Dep.target = watcher;
}
